import { render } from "./ModalBase.vue?vue&type=template&id=6966728e&scoped=true&ts=true"
import script from "./ModalBase.vue?vue&type=script&lang=ts"
export * from "./ModalBase.vue?vue&type=script&lang=ts"

import "./ModalBase.vue?vue&type=style&index=0&id=6966728e&scoped=true&lang=scss"

import exportComponent from "D:\\02_システム\\20_帳票テンプレート\\02_開発\\report-template\\web-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6966728e"]])

export default __exports__